import { Directive, HostBinding, Input } from '@angular/core';

type CardImagePlacement = 'top' | 'bottom';

/**
 * Card image placement component
 */
@Directive({
  selector: '[atxCardImage]',
  standalone: false,
})
export class CardImageDirective {
  /** Image placement */
  @Input('atxCardImage')
  public placement: CardImagePlacement;

  /** Host binding if no placement specified */
  @HostBinding('class.card-img')
  public get noPlacement(): boolean {
    return !this.placement;
  }

  /** Image top placement */
  @HostBinding('class.card-img-top')
  public get topPlacement(): boolean {
    return this.placement === 'top';
  }

  /** Image bottom placement */
  @HostBinding('class.card-img-bottom')
  public get bottomPlacement(): boolean {
    return this.placement === 'bottom';
  }
}
